import React from 'react';
import { IconChevronDown } from '@tabler/icons-react';

// A plain <select>'s native dropdown arrow doesn't reliably respect
// padding-right the same way across browsers — padding alone (pr-8, pr-10...)
// kept drifting back to looking cramped. This hides the native arrow
// entirely (appearance-none) and draws our own, at a fixed, guaranteed
// distance from the edge — so it can't drift again regardless of browser.
export default function SelectField({ className = '', children, ...props }) {
  return (
    <div className="relative">
      <select
        {...props}
        className={`w-full appearance-none border border-border rounded-lg pl-2 pr-8 py-1.5 text-sm text-ink bg-card focus:outline-none focus:ring-2 focus:ring-gold ${className}`}
      >
        {children}
      </select>
      <IconChevronDown
        size={14}
        stroke={2}
        className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-muted"
      />
    </div>
  );
}
